import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "@/material-dashboard";

import App from "./App.vue";

// router setup
import router from "./routes/routes";
import { initializeKakao } from '@/utils/kakao';

// store setup
import Vuex from 'vuex';
import store from '@/store';

// import 'jodit/es5/jodit.min.css';
import 'jodit/build/jodit.min.css';
// import 'jodit-vue/node_modules/jodit/build/jodit.min.css';
import "@/assets/styles/paper-preview.css";



/* Plugins */
import vuetify from '@/plugins/vuetify.js';
import i18n from '@/plugins/i18n';
import "@/plugins/sweetalert2";


// kakao 정보 초기화
initializeKakao(process.env.VUE_APP_KAKAO_AUTH_JS_API_KEY);

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);

Vue.config.productionTip = false;

/* eslint-disable no-new */
export const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
